// extracted by mini-css-extract-plugin
export default {"infoButton":"info-module__infoButton--ZuEK8"};